import Vue from 'vue';
import each from 'lodash/each';

if (window.Bus === undefined) {
    window.Bus = new Vue();
}

export default {
    bind(el, binding, vnode) {
        const originalSilent = window.Vue.config.silent;

        window.Vue.config.silent = true;
        vnode.context.$data['hello'] = 'world';
        window.Vue.config.silent = originalSilent;
    },
    update() {},
};
